export const CategoryIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 16 }
		height={ 16 }
		fill="none"
	>
		<g fill="#F26C0D" clipPath="url(#a)">
			<path d="M13.056 5.71c0-.804-.327-1.526-.854-2.035a2.875 2.875 0 0 0-3.526-.443 3.181 3.181 0 0 0-.821.738l.018.017c.246.182.46.36.639.56.295.311.541.656.722 1.049.084 0 .182-.018.262-.018.886 0 1.674.36 2.266.937.065.065.13.148.196.214.197.229.36.508.476.788a2.864 2.864 0 0 0 .622-1.807ZM10.183 2.016c.23 0 .426-.196.426-.425V.425A.433.433 0 0 0 10.183 0a.434.434 0 0 0-.428.425v1.166c0 .229.2.425.428.425ZM13.4 3.099l.822-.82a.418.418 0 1 0-.592-.592l-.82.82a.418.418 0 1 0 .59.592ZM15.482 5.299h-1.165a.433.433 0 0 0-.425.425c0 .23.196.426.425.426h1.165c.23 0 .426-.197.426-.426-.015-.229-.194-.425-.425-.425ZM13.4 8.35a.418.418 0 1 0-.59.591l.82.821a.418.418 0 1 0 .591-.591l-.82-.821ZM6.951 3.099a.418.418 0 1 0 .592-.592l-.82-.82c-.15-.182-.426-.182-.592 0a.418.418 0 0 0 0 .591l.82.82ZM8.983 11.867H.99a.553.553 0 0 0 0 1.107h7.995c.607 0 1.1.491 1.1 1.098a.83.83 0 1 1-1.659-.003.551.551 0 1 0-1.102 0c0 1.065.866 1.931 1.93 1.931 1.065 0 1.931-.866 1.931-1.93 0-1.217-.989-2.203-2.202-2.203Z" />
			<path
				fillRule="evenodd"
				d="M8.543 6.643c.297-.148.624-.214.969-.214.64 0 1.23.265 1.651.687.428.426.69 1 .69 1.657 0 .64-.264 1.23-.69 1.656a2.452 2.452 0 0 1-1.674.705H2.023A1.961 1.961 0 0 1 .054 9.166a1.961 1.961 0 0 1 1.969-1.969.37.37 0 0 0 .229-.065.406.406 0 0 0 .181-.295c.116-.77.509-1.46 1.067-1.936a3.26 3.26 0 0 1 2.085-.77 3.21 3.21 0 0 1 1.822.574c.41.264.74.64 1.002 1.1-.065.018-.13.05-.196.083-.41.181-.77.443-1.083.788a.404.404 0 0 0 .033.591.404.404 0 0 0 .592-.032c.214-.265.493-.46.788-.592ZM2.1 10a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export const ProBlocksCategoryIcon = () => (
	<svg
		width={ 18 }
		height={ 18 }
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
			fill="#4ab866"
			fillOpacity={ 0.1 }
		/>
		<path
			d="M9 .5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Z"
			stroke="#4ab866"
			strokeOpacity={ 0.6 }
		/>
		<g clipPath="url(#a)" fill="#4ab866">
			<path
				d="M10.386 7.761a.84.84 0 0 0 .557.428.78.78 0 0 0 .69-.195l1.46-1.34-.473 3.767H5.39l-.475-3.767 1.462 1.34a.78.78 0 0 0 .69.195.84.84 0 0 0 .557-.428l1.38-2.533z"
				stroke="#4ab866"
				strokeWidth={ 0.847 }
			/>
			<path d="M12.577 13.282H5.432c-.23 0-.416-.228-.416-.508v-1.117h7.977v1.117c0 .28-.186.508-.416.508" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M4 4h10v10H4z" />
			</clipPath>
		</defs>
	</svg>
);

// Reset Icon.
export const ResetIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 12 }
		height={ 12 }
		fill="none"
	>
		<g clipPath="">
			<path
				stroke="#949494"
				fill="#fff"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={ 1.5 }
				d="M1.943 3.528a4.751 4.751 0 1 1-.514 3.765m.305-5.156.02 1.605 1.545-.13"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h12v12H0z" />
			</clipPath>
		</defs>
	</svg>
);
export const InfoIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 18 }
		height={ 18 }
		viewBox="0 0 1200 1200"
	>
		<path
			fill="#aaa"
			d="M198 198c-222 222-222 582 0 804s582 222 804 0 222-582 0-804-582-222-804 0zm712.8 712.8c-171.6 171.6-451.2 171.6-622.8 0-171.6-171.6-171.6-451.2 0-622.8s451.2-171.6 622.8 0c172.8 172.8 172.8 451.2 0 622.8zM535.2 357.6c0-48 39.602-86.398 87.602-86.398s86.398 39.602 85.199 87.602c0 48-39.602 87.602-86.398 86.398-48-.004-87.602-39.602-86.402-87.602zm210 499.2c-2.398 7.2-7.2 15.602-12 20.398-31.199 32.398-69.602 50.398-114 51.602-21.602 0-42 0-63.602-3.602-34.801-4.8-79.199-48-72-93.602 4.8-31.199 9.602-62.398 14.398-93.602 9.602-54 19.199-108 28.801-162 0-3.601 1.2-7.199 1.2-10.8 0-22.802-7.2-31.2-30-33.603-9.602-1.199-19.2-2.398-28.802-4.8-10.8-3.602-15.602-13.2-15.602-21.602 1.2-9.602 7.2-15.602 19.2-18 6-1.2 13.198-1.2 19.198-1.2h163.2c20.397 0 32.397 9.602 32.397 30 0 16.801-2.398 33.602-6 50.398-10.8 62.398-22.8 123.6-33.602 186-3.601 20.398-8.398 40.801-10.8 61.2-1.2 9.601 0 20.397 2.398 30 3.601 13.198 13.199 20.397 26.398 18 10.8-1.2 21.602-4.801 32.398-9.602 8.398-3.602 15.602-9.602 24-12 15.617-5.988 26.418 3.613 22.816 16.812z"
		/>
	</svg>
);
export const PopOverToggleIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 24 }
		height={ 24 }
		fill="none"
	>
		<rect
			width={ 22.4 }
			height={ 22.4 }
			x={ 0.8 }
			y={ 0.8 }
			fill="#fff"
			rx={ 3.2 }
		/>
		<rect
			width={ 22.4 }
			height={ 22.4 }
			x={ 0.8 }
			y={ 0.8 }
			stroke="#2F2F2F"
			strokeWidth={ 1.6 }
			rx={ 3.2 }
		/>
		<path
			fill="#2F2F2F"
			d="M19.584 7.938a.813.813 0 0 0-.813-.813H11.32a2.439 2.439 0 0 0-4.598 0H5.23a.813.813 0 0 0 0 1.625h1.493a2.439 2.439 0 0 0 4.598 0h7.451a.813.813 0 0 0 .813-.813ZM19.584 16.063a.813.813 0 0 0-.813-.813h-1.493a2.439 2.439 0 0 0-4.597 0H5.229a.813.813 0 0 0 0 1.625h7.452a2.439 2.439 0 0 0 4.597 0h1.493a.813.813 0 0 0 .813-.813Z"
		/>
	</svg>
);
export const AppearanceIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="none"
		viewBox="0 0 16 16"
	>
		<path
			fill="#2F2F2F"
			d="M13.456 11.027a1.6 1.6 0 0 1-.146.3 6.24 6.24 0 0 1-3.22 2.56c-1.35.471-2.833.46-4.178-.032a6.18 6.18 0 0 1-3.5-3.213 6.18 6.18 0 0 1-.208-4.747l.004-.012C3.38 2.68 6.94 1.013 10.151 2.17l.094.035a2.97 2.97 0 0 1 1.666 1.568 3 3 0 0 1 .084 2.284l-.598 1.635a.85.85 0 0 0 .506 1.09l.612.224c.449.164.796.518.95.97.12.347.114.716-.009 1.052M3.35 6.3l-.004.01a5.01 5.01 0 0 0 2.984 6.405 5.024 5.024 0 0 0 5.952-2.034.36.36 0 0 0 .036-.312.36.36 0 0 0-.22-.224l-.61-.223a2.066 2.066 0 0 1-1.23-2.647l.598-1.636a1.8 1.8 0 0 0-1.039-2.3l-.076-.028a5.01 5.01 0 0 0-6.391 2.99"
		></path>
		<path
			fill="#2F2F2F"
			d="M7.597 11.369a.73.73 0 1 1-1.37-.503.73.73 0 0 1 1.37.503M5.629 7.134a.73.73 0 1 1-1.37-.503.73.73 0 0 1 1.37.503m1.71-1.86A.73.73 0 1 1 5.97 4.77a.73.73 0 0 1 1.37.502M5.736 9.658a.73.73 0 1 1-1.369-.503.73.73 0 0 1 1.37.503"
		></path>
	</svg>
);
export const ArrowUpRight = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 14 }
		height={ 14 }
		viewBox="0 0 14 14"
		fill="none"
	>
		<path
			d="M4.55469 10.3882C4.29434 10.6485 3.87168 10.6485 3.61133 10.3882C3.35125 10.1279 3.35136 9.70612 3.61133 9.4458L4.55469 10.3882ZM10.5831 9.9165C10.5831 10.2847 10.2842 10.5835 9.91602 10.5835C9.54798 10.5833 9.25 10.2846 9.25 9.9165V5.69287L4.55469 10.3882L4.08301 9.9165L3.61133 9.4458L8.30664 4.75049H4.08301C3.71482 4.75049 3.41602 4.45168 3.41602 4.08349C3.41602 3.7153 3.71482 3.4165 4.08301 3.4165H9.91602C10.2842 3.4165 10.5831 3.7153 10.5831 4.08349V9.9165Z"
			fill="#2271b1"
		/>
	</svg>
);

export const RightSymbolIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ 12 }
		height={ 12 }
		fill="none"
	>
		<path
			fill="#1A74E4"
			d="M6.028 0H6a6.03 6.03 0 0 0-4.817 2.422A5.95 5.95 0 0 0 0 6c0 1.146.324 2.26.938 3.221a6.017 6.017 0 0 0 2.434 2.174A5.942 5.942 0 0 0 6 12H6.028C9.32 11.984 12 9.292 12 6S9.32.016 6.028 0Zm3.55 4.727L5.815 8.492a.857.857 0 0 1-1.22 0L2.42 6.318a.865.865 0 0 1 .61-1.473c.231 0 .448.09.611.253l1.564 1.564 3.154-3.154a.857.857 0 0 1 .61-.253c.23 0 .447.09.61.253.163.163.253.38.253.61 0 .23-.09.447-.253.61Z"
		/>
	</svg>
);

export const VideoTooltipIcon = ( { color = '#BBC2C7' } ) => (
	<svg
		width={ 16 }
		height={ 16 }
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={ { display: 'block' } }
	>
		<path
			d="M7.9 14.9a7 7 0 1 0 0-14 7 7 0 0 0 0 14z"
			stroke={ color }
			strokeWidth={ 1.8 }
			strokeMiterlimit={ 10 }
		/>
		<path
			d="M11.1 7.9 6.1 5v5.8l5-2.9z"
			stroke={ color }
			strokeWidth={ 1.5 }
			strokeMiterlimit={ 10 }
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
